import styled from '@emotion/styled';

export const Label = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.InkSecondary};
`;
